// this is generated via google sheet json export
export default {
  seoTitle: "NHL Picks - NHL predictions today and for every game",
  news: {
    seoTitle: "NHL Sports Betting News | BetQL",
  },
  description:
    "The best choice for NHL picks. Get the latest NHL predictions today, with up to the minute odd, lines and spreads.",
  "free-pick-predictions": {
    seoTitle: "Free NHL Picks | NHL Predictions | BetQL",
    h1: "BetQL Free NHL Picks",
  },
  "best-bets": {
    seoTitle: "NHL Spreads | NHL Odds | BetQL",
    h1: "NHL Trending Bets",
    description:
      "Check out BetQL for the latest NHL odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
  },
  odds: {
    seoTitle: "NHL Lines | NHL Odds | BetQL",
    h1: "NHL Model Bets for Tonight",
    description:
      "Check out BetQL for the latest NHL odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
    "ats-odds": {
      seoTitle: "NHL ATS Odds | NHL Against The Spread Odds | BetQL",
      h1: "NHL ATS Model Bets for Tonight",
      description:
        "Check out BetQL for the latest NHL ATS odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "first-period-ats-odds": {
      seoTitle: "NHL 1st Period ATS Odds | BetQL",
      h1: "NHL 1st Period ATS Model Bets",
      description:
        "Check out BetQL for the latest NHL 1st period ATS odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "first-period-moneyline": {
      seoTitle: "NHL 1st Period Odds | NHL 1st Period Moneylines | BetQL",
      h1: "NHL 1st Period Money Line Model Bets",
      description:
        "Check out BetQL for the latest NHL 1st period money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "second-period-ats-odds": {
      seoTitle: "NHL 2nd Period ATS Odds | BetQL",
      h1: "NHL 2nd Period ATS Model Bets",
      description:
        "Check out BetQL for the latest NHL second period ATS odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "second-period-moneyline": {
      seoTitle: "NHL 2nd Period Odds | NHL 2nd Period Moneylines | BetQL",
      h1: "NHL 2nd Period Money Line Model Bets",
      description:
        "Check out BetQL for the latest NHL second period odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "third-period-ats-odds": {
      seoTitle: "NHL 3rd Period ATS Odds | BetQL",
      h1: "NHL 3rd Period ATS Model Bets",
      description:
        "Check out BetQL for the latest NHL third period ATS odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "third-period-moneyline": {
      seoTitle: "NHL 3rd Period Odds | NHL 3rd Period Moneylines | BetQL",
      h1: "NHL 3rd Period Money Line Model Bets",
      description:
        "Check out BetQL for the latest NHL third period odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "totals-spread": {
      seoTitle: "NHL Over Unders | NHL Over Under Odds | BetQL",
      h1: "NHL Over Under Picks",
      description:
        "Check out BetQL for the latest NHL over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "first-period-totals-spread": {
      seoTitle: "NHL Odds 1st Period Total | BetQL",
      h1: "NHL 1st Period Over Under Model Bets",
      description:
        "Check out BetQL for the latest NHL 1st period over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    moneyline: {
      seoTitle: "NHL Odds Moneyline | BetQL",
      h1: "NHL Money Line Model Bets",
      description:
        "Check out BetQL for the latest NHL money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
  },
  "line-movement": {
    seoTitle: "NHL Line Movement | NHL Betting Line Movement | BetQL",
    h1: "NHL Line Movement",
    description:
      "Check out BetQL for the latest NHL betting line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
    "ats-odds": {
      seoTitle: "NHL ATS Line Movement | BetQL",
      h1: "NHL Puck Line Movement",
      description:
        "Check out BetQL for the latest NHL ATS line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "first-period-ats-odds": {
      seoTitle: "NHL 1st Period ATS Line Movement | BetQL",
      h1: "NHL 1st Period Line Movement",
      description:
        "Check out BetQL for the latest NHL first period ATS line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "first-period-moneyline": {
      seoTitle: "NHL 1st Period Moneyline Movement | BetQL",
      h1: "NHL 1st Period Money Line Movement",
      description:
        "Check out BetQL for the latest NHL first period line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "first-period-totals-spread": {
      seoTitle: "NHL Line Movement 1st Period Total | BetQL",
      h1: "NHL 1st Period Over Under Line Movement",
      description:
        "Check out BetQL for the latest NHL first period over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    moneyline: {
      seoTitle: "NHL Line Movement Moneyline | BetQL",
      h1: "NHL Money Line Movement",
      description:
        "Check out BetQL for the latest NHL line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "second-period-ats-odds": {
      seoTitle: "NHL 2nd Period ATS Line Movement | BetQL",
      h1: "NHL 2nd Period Line Movement",
      description:
        "Check out BetQL for the latest NHL second period ATS line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "second-period-moneyline": {
      seoTitle: "NHL 2nd Period Moneyline Movement | BetQL",
      h1: "NHL 2nd Period Money Line Movement",
      description:
        "Check out BetQL for the latest NHL second period line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "third-period-ats-odds": {
      seoTitle: "NHL 3rd Period ATS Line Movement | BetQL",
      h1: "NHL 3rd Period Line Movement",
      description:
        "Check out BetQL for the latest NHL third period ATS line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "third-period-moneyline": {
      seoTitle: "NHL 3rd Period Moneyline Movement | BetQL",
      h1: "NHL 3rd Period Money Line Movement",
      description:
        "Check out BetQL for the latest NHL third period line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "totals-spread": {
      seoTitle: "NHL Over Under Line Movement | BetQL",
      h1: "NHL Over Under Line Movement",
      description:
        "Check out BetQL for the latest NHL over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
  },
  "public-betting": {
    seoTitle: "NHL Public Betting | NHL Public Betting Percentages | BetQL",
    h1: "NHL Consensus Picks",
    description:
      "Check out BetQL for the latest NHL consensus picks for tonight's games. Get the most updated odds, lines, spreads, and picks from BetQL.",
    "ats-odds": {
      seoTitle: "NHL Public ATS Betting | BetQL",
      h1: "NHL Consensus Picks Against the Spread",
      description:
        "Check out BetQL for the latest NHL ATS consensus picks for tonight's games. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "first-period-ats-odds": {
      seoTitle: "NHL Public 1st Period ATS Picks | BetQL",
      h1: "NHL 1st Period Public Picks ATS",
      description:
        "Check out BetQL for the latest NHL first period ATS consensus picks for tonight's games. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "first-period-moneyline": {
      seoTitle: "NHL Public 1st Period Moneyline Picks | BetQL",
      h1: "NHL 1st Period Money Line Public Picks",
      description:
        "Check out BetQL for the latest NHL first period money line consensus picks for tonight's games. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "first-period-totals-spread": {
      seoTitle: "NHL Public Betting 1st Period Total | BetQL",
      h1: "NHL 1st Period Over Under Public Betting",
      description:
        "Check out BetQL for the latest NHL first over under consensus picks for tonight's games. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    moneyline: {
      seoTitle: "NHL Public Betting Moneyline | BetQL",
      h1: "NHL Money Line Public Betting",
      description:
        "Check out BetQL for the latest NHL money line consensus picks for tonight's games. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "second-period-ats-odds": {
      seoTitle: "NHL Public 2nd Period ATS Picks | BetQL",
      h1: "NHL 2nd Period Public Picks ATS",
      description:
        "Check out BetQL for the latest NHL second period ATS consensus picks for tonight's games. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "second-period-moneyline": {
      seoTitle: "NHL Public 2nd Period Moneyline Picks | BetQL",
      h1: "NHL 2nd Period Money Line Public Picks",
      description:
        "Check out BetQL for the latest NHL second period money line consensus picks for tonight's games. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "third-period-ats-odds": {
      seoTitle: "NHL Public 3rd Period ATS Picks | BetQL",
      h1: "NHL 3rd Period Public Picks ATS",
      description:
        "Check out BetQL for the latest NHL third period ATS consensus picks for tonight's games. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "third-period-moneyline": {
      seoTitle: "NHL Public 3rd Period Moneyline Picks | BetQL",
      h1: "NHL 3rd Period Money Line Public Picks",
      description:
        "Check out BetQL for the latest NHL third period money line consensus picks for tonight's games. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "totals-spread": {
      seoTitle: "NHL Public Over Under Betting | BetQL",
      h1: "NHL Over Under Public Picks",
      description:
        "Check out BetQL for the latest NHL over under consensus picks for tonight's games. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
  },
  "sharp-picks": {
    seoTitle: "NHL Sharp Picks | NHL Sharp Betting | BetQL",
    h1: "NHL Expert Picks",
    description:
      "Check out BetQL for the latest NHL expert picks for tonight's games. Get the most updated odds, lines, spreads, and picks from BetQL.",
    "ats-odds": {
      seoTitle: "NHL Sharp ATS Picks | BetQL",
      h1: "NHL Picks Against the Spread",
      description:
        "Check out BetQL for the latest NHL expert ATS picks for tonight's games. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "first-period-ats-odds": {
      seoTitle: "NHL Sharp 1st Period ATS Picks | BetQL",
      h1: "NHL 1st Period Picks Against the Spread",
      description:
        "Check out BetQL for the latest NHL expert first period ATS picks for tonight's games. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "first-period-moneyline": {
      seoTitle: "NHL Sharp 1st Period Moneyline Picks | BetQL",
      h1: "NHL 1st Period Picks",
      description:
        "Check out BetQL for the latest NHL expert first period money line picks for tonight's games. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "first-period-totals-spread": {
      seoTitle: "NHL Sharp Picks 1st Period Total | BetQL",
      h1: "NHL 1st Period Over Under Expert Picks",
      description:
        "Check out BetQL for the latest NHL expert first period over under picks for tonight's games. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    moneyline: {
      seoTitle: "NHL Sharp Picks Moneyline | BetQL",
      h1: "NHL Money Line Picks",
      description:
        "Check out BetQL for the latest NHL expert money line picks for tonight's games. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "second-period-ats-odds": {
      seoTitle: "NHL Sharp 2nd Period ATS Picks | BetQL",
      h1: "NHL 2nd Period Picks Against the Spread",
      description:
        "Check out BetQL for the latest NHL expert 2nd period ATS picks for tonight's games. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "second-period-moneyline": {
      seoTitle: "NHL Sharp 2nd Period Moneyline Picks | BetQL",
      h1: "NHL 2nd Period Picks",
      description:
        "Check out BetQL for the latest NHL expert 2nd period money line picks for tonight's games. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "third-period-ats-odds": {
      seoTitle: "NHL Sharp 3rd Period ATS Picks | BetQL",
      h1: "NHL 3rd Period Picks Against the Spread",
      description:
        "Check out BetQL for the latest NHL expert 3rd period ATS picks for tonight's games. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "third-period-moneyline": {
      seoTitle: "NHL Sharp 3rd Period Moneyline Picks | BetQL",
      h1: "NHL 3rd Period Picks",
      description:
        "Check out BetQL for the latest NHL expert 3rd period money line picks for tonight's games. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "totals-spread": {
      seoTitle: "NHL Sharp Over Under Picks | BetQL",
      h1: "NHL Over Under Picks",
      description:
        "Check out BetQL for the latest NHL expert over under picks for tonight's games. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
  },
};
